import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import { TelaTrocarSenhaObrigatoria } from "./components/layout/trocar-senha";
import { ErroApi } from "./lib/api";
import { ProvedorSessao, useSessaoQuery } from "./lib/sessao";
import { router } from "./router";
import { TelaLogin } from "./routes/login";
import "./styles/app.css";

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (n, e) => !(e instanceof ErroApi && e.status >= 400 && e.status < 500) && n < 2,
      refetchOnWindowFocus: true,
    },
  },
});

function App() {
  const sessao = useSessaoQuery();
  if (sessao.isPending) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <Loader2 className="animate-spin text-gold-500" />
      </div>
    );
  }
  if (!sessao.data) return <TelaLogin />;
  if (sessao.data.deveTrocarSenha) return <TelaTrocarSenhaObrigatoria nome={sessao.data.nome} />;
  return (
    <ProvedorSessao usuario={sessao.data}>
      <RouterProvider router={router} />
    </ProvedorSessao>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <App />
      <Toaster
        position="bottom-center"
        offset={{ bottom: 96 }}
        mobileOffset={{ bottom: 96 }}
        closeButton
        toastOptions={{ style: { fontFamily: "Raleway, sans-serif" } }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
